import React from 'react';
import { Link } from '@amzn/storm-ui';
import { BANNER_LEVEL, BANNER_TYPE } from 'src/app/slice';
import { LinkTemplate, TextTemplate } from '@amzn/aces-communications-api';
import { clickLinkHandler } from './utils';
import { BannerText } from 'src/features/header/components/Banners/styles';

// Both sub-components are looked up from `acesComponentMap` by `component.type`,
// so their static type cannot be correlated to the concrete template. They share
// one props shape (keeping the map values homogeneous so the call site type-checks)
// and each narrows `component` to the template it is only ever mapped for.
type AcesBannerComponentProps = {
  component: TextTemplate | LinkTemplate;
  bannerLevel: BANNER_LEVEL;
  bannerId: string;
};

const AcesTextComponent = ({ component }: AcesBannerComponentProps) => {
  const textComponent = component as TextTemplate;
  return (
    <BannerText>
      {textComponent.strong ? (
        <strong>{textComponent.text}</strong>
      ) : (
        textComponent.text
      )}{' '}
    </BannerText>
  );
};

const AcesLinkComponent = ({
  component,
  bannerLevel,
  bannerId,
}: AcesBannerComponentProps) => {
  const linkComponent = component as LinkTemplate;
  return (
    <>
      {linkComponent.prefix}
      {linkComponent.prefix && <> </>}
      <Link
        href={linkComponent.url}
        onClick={() => clickLinkHandler(bannerLevel, bannerId)}
      >
        {linkComponent.text}
      </Link>{' '}
    </>
  );
};

const acesComponentMap = {
  Text: AcesTextComponent,
  Link: AcesLinkComponent,
};

export const AcesBannerContent: React.VFC<{
  acesBannerContent: (TextTemplate | LinkTemplate)[];
  bannerLevel: BANNER_LEVEL;
  bannerId: string;
  bannerType: BANNER_TYPE;
}> = ({ acesBannerContent, bannerLevel, bannerId }) => {
  return (
    <>
      {acesBannerContent.map((component, index) => {
        const MappedComponent = acesComponentMap[component.type];
        if (!MappedComponent) {
          return null;
        }
        return (
          <MappedComponent
            component={component}
            bannerLevel={bannerLevel}
            bannerId={bannerId}
            key={`${bannerId}-${index}`}
          />
        );
      })}
    </>
  );
};
